import { useRouteMatch } from 'react-router-dom'

import { useDeleteAnnotationReplyMutation } from '@sketch/gql-types'

import { removeFromPaginated } from '../../utils/apolloCache'
import { routes, usePreviewPwd } from '../../routes'

interface useDeleteAnnotationCommentProps {
  identifier: string
  onCompleted?: () => void
  skipCache?: boolean
}

const useDeleteAnnotationReply = ({
  identifier,
  onCompleted,
}: useDeleteAnnotationCommentProps) => {
  const previewRouteMatch = useRouteMatch<{ previewID?: string }>(
    routes.PREVIEW_VIEW.template()
  )
  const previewIdentifier = previewRouteMatch?.params.previewID
  const previewPassword = usePreviewPwd(previewIdentifier || '')

  const [mutate, { loading }] = useDeleteAnnotationReplyMutation({
    variables: { identifier, previewIdentifier, previewPassword },
    onError: 'show-toast',
    onCompleted: () => {
      onCompleted && onCompleted()
    },
    update: (cache, { data }) => {
      if (!data) {
        return
      }
      removeFromPaginated(
        cache,
        { __typename: 'Comment', identifier },
        () => true
      )
    },
  })
  return [mutate, { loading }] as const
}

export default useDeleteAnnotationReply
